const PHONE = '[PHONE NUMBER]';
const EMAIL = '[EMAIL ADDRESS]';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/be8dc42e54189fcc8447eef73112d3e5.jpg"
          alt="Northern Michigan home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark/70 via-navy-dark/60 to-navy-dark/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-8 py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-8">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-line text-accent-light"></i>
          </div>
          Serving Northern Michigan &amp; Up North Communities
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          Thorough, Reliable Home<br className="hidden md:block" /> Inspections in Northern Michigan
        </h1>

        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-4">
          Precision North Home Inspections helps buyers, sellers, and homeowners make confident decisions with professional inspection services built on honesty and detail.
        </p>

        {/* Trust line */}
        <p className="text-accent-light font-medium text-sm md:text-base tracking-wide mb-10">
          Straightforward service, clear reporting, and local reliability.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="w-full sm:w-auto px-8 py-4 bg-accent hover:bg-accent-light text-white font-semibold rounded-md cursor-pointer transition-colors duration-200 whitespace-nowrap text-base"
          >
            Schedule an Inspection
          </a>
          <a
            href={`tel:${PHONE}`}
            className="w-full sm:w-auto px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold rounded-md cursor-pointer transition-colors duration-200 whitespace-nowrap text-base flex items-center justify-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            Call Now
          </a>
        </div>

        {/* Contact Quick Info */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/70 text-sm">
          <a href={`tel:${PHONE}`} className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-accent-light"></i>
            </div>
            {PHONE}
          </a>
          <span className="hidden sm:block text-white/30">|</span>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-fill text-accent-light"></i>
            </div>
            {EMAIL}
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/40 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
